import { ModelBase } from '../../core/model/model-base';
import { LocalDate } from '../../core/model/local-date';
import { Money } from '../../core/model/money';

export class InvoiceTransaction extends ModelBase {
  constructor() {
    super();

    Object.defineProperties(this, {
      _businessTransactionDateDate: { enumerable: false, writable: true },
      _invoiceDueDate: { enumerable: false, writable: true },
    });
  }

  private _businessTransactionDate: LocalDate;
  private _invoiceDueDate: LocalDate;

  amount: Money;
  invoiceAmount: Money;
  invoiceUnPaidAmount: Money;
  invoiceVatAmount: Money;
  invoiceRefersToPeriod: string;
  paymentOcr: string;
  verificationDescription: string;
  debtorName: string;
  paymentNameAndAddress: string;
  registrationTypeText: string;

  get businessTransactionDate(): LocalDate {
    return this._businessTransactionDate;
  }
  set businessTransactionDate(value: LocalDate) {
    this._businessTransactionDate = LocalDate.fromDate(value);
  }

  get invoiceDueDate(): LocalDate {
    return this._invoiceDueDate;
  }
  set invoiceDueDate(value: LocalDate) {
    this._invoiceDueDate = LocalDate.fromDate(value);
  }
}
